import { useMounted } from 'shared/hooks/utils';
import { useCallback, useEffect, useRef } from 'react';
import { useAppSelector } from 'shared/hooks/redux/hooks';
export function useAutoFillSSID(setName, setError, setIp) {
    const isMounted = useMounted();
    const addIntervalRef = useRef();
    const { idle } = useAppSelector((state) => state.idle);
    const autofillSSID = useCallback(async () => {
        try {
            await new Promise((resolve, reject) => window.wifi.checkLocation(resolve, reject))
                .then(async (success) => {
                console.log('checkLocation success', success);
                clearInterval(addIntervalRef.current);
                await new Promise((resolve, reject) => window.wifi.getConnectedInfo(resolve, reject))
                    .then((result) => {
                    const { ssid, ip, is5G, bssid, state } = result;
                    if (is5G) {
                        setError('Подключитесь к сети 2.4Ггц!');
                        return;
                    }
                    console.log('ip', ip);
                    console.log('bssid', bssid);
                    console.log('state', state);
                    clearInterval(addIntervalRef.current);
                    setIp(ip);
                    setName(ssid);
                    setError(null);
                })
                    .catch((error) => {
                    console.log('autofillSSID error', error);
                    if (error.state == 'NotConnected') {
                        setError('WiFi не подключен');
                        addIntervalRef.current = setInterval(autofillSSID, 2e3);
                    }
                    else if (error.state == 'Connecting') {
                        setError('WiFi в процессе подключения');
                    }
                });
            })
                .catch((error) => {
                console.log('checkLocation error', error);
                if (error === 'NOT_DETERMINATED') {
                    addIntervalRef.current = setInterval(autofillSSID, 2e3);
                }
                setError(error === 'NOT_GRANTED'
                    ? 'У приложения нет доступа к геопозиции'
                    : error);
            });
        }
        catch (e) {
            console.error('FAILED GET SSID:', e);
        }
    }, [setName, setIp, setError]);
    useEffect(() => {
        if (isMounted.current) {
            autofillSSID()
                .then(() => console.log('autofillSSID — done'))
                .catch((err) => console.error('autoFillSSid', JSON.stringify(err)));
        }
    }, [idle]);
}
